module.exports = __webpack_public_path__ + "img/bg1.9301744d.jpg";